import instanceAPI from 'services/apis/axiosconfig';

export const getDetailExperience = (id) => {
  const request = instanceAPI.get(`/public/get-experience-detail/${id}`);
  return request.then((res) => ({
    ...res,
    data: {
      results: res.data,
    },
  }));
};
